
import kotlinx.browser.document
import kotlinx.browser.window
import react.create
import react.dom.client.createRoot
import web.dom.Element


@ExperimentalJsExport
fun main() {
        val companyName = "Nusquam"
        val legalForm = "GmbH"
    StringBuilder("$companyName $legalForm")

        window.onload = {

            // rendering the head does not work yet.
            // Turning this on removes a lot of attributes and css from the body
//            render(document.head) {
//                child(DocumentHead::class) {
//                    attrs {
//                        titleName = fullCompanyName.toString()
//                    }
//                }
//            }
            document.body!!.style.backgroundColor = BaseLayoutStyles.baseColor.toString()
//            val container = document.getElementById("root")!!
            val container = (document.getElementById("root") as Element?) ?: error("Couldn't find container!")
            val createdRoot = createRoot(container)
            val baseLayout = BaseLayout()
            createdRoot.render(baseLayout.createdTable.create())
            // Clean up the plot div handling
//            val contentDiv = document.getElementById("test")
//            contentDiv?.let { div ->
//                try {
//                    div.appendChild(plotDiv)
//                } catch (e: Exception) {
//                    console.error("Failed to append plot div", e)
//                }
//            }


        }

    }
